import { useNavigate } from "react-router-dom";
import styled from "styled-components";
import { CardComp, ButtonComp } from "../../../components";

const PageWrap = styled.div`
  min-height: calc(100vh - 120px);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px 16px;
  background: linear-gradient(
    165deg,
    rgba(49, 119, 140, 0.06) 0%,
    rgba(139, 49, 58, 0.04) 50%,
    #ffffff 100%
  );
`;

export default function ModuleUnavailablePage({ moduleName = "This module" }) {
  const navigate = useNavigate();

  return (
    <PageWrap className="mx-2 mx-lg-4">
      <CardComp cardClassName="border-0 shadow-sm w-100" cardBodyClassName="p-0">
        <div
          className="px-3 py-4 py-md-5 text-center d-flex flex-column align-items-center mx-auto"
          style={{ maxWidth: 560 }}
        >
          <div
            className="mb-4 d-flex align-items-center justify-content-center rounded-circle"
            style={{
              width: 88,
              height: 88,
              background: "rgba(139, 49, 58, 0.1)",
              color: "var(--color-primary)",
            }}
          >
            <svg width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.75" aria-hidden>
              <path d="M12 9v4m0 4h.01M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z" />
            </svg>
          </div>
          <h1 className="fw-bold mb-2" style={{ color: "#383838", fontSize: "1.5rem" }}>
            {moduleName} unavailable
          </h1>
          <p className="text-muted mb-4" style={{ maxWidth: 440, lineHeight: 1.6 }}>
            This feature is not enabled for your organization. Contact your platform administrator
            if you believe you should have access.
          </p>
          <ButtonComp
            btnText="Back to dashboard"
            btnClassName="text-white px-4 py-2 rounded"
            ButtonInlineStyle={{
              backgroundColor: "var(--color-primary)",
              border: "none",
              minWidth: 200,
            }}
            onClick={() => navigate("/super_admin/dashboard")}
          />
        </div>
      </CardComp>
    </PageWrap>
  );
}
